import { onBeforeUnmount, onGlobalSetup } from '@nuxtjs/composition-api';
import { useDebug } from '@/composables/useDebug';
import { useDevice } from '~/composables/useDevice';
import { eventBus } from '~/modules/common/utils/eventBus';

export default function (ctx, inject) {
  onGlobalSetup(() => {
    const { oLog } = useDebug('Oio');
    const deviceState = useDevice();

    window.refreshProjectUnit = {};
    window.oio = window.oio || {};

    window.oio.init = function (...args) {
      this.initializers = this.initializers || [];
      this.initializers.push(args);
    };

    const fallbackOutstreamFunction = () => {
      oLog('initializeAdformOutstream called but not initiliazed');
    };

    window.initializeAdformOutstream = window.initializeAdformOutstream || fallbackOutstreamFunction;

    window.require = (moduleName) => {
      if (moduleName === 'info') {
        return {
          page: {
            viewScope: deviceState.isMobile.value ? 'mobile' : 'desktop',
          },
        };
      } else if (moduleName === 'ga') {
        return {
          trackEvent(category, action, label, value) {
            window.gtag('event', action, {
              event_category: category,
              event_label: label,
              value,
            });
          },
        };
      }
    };

    function processInitializers() {
      if (window.oio.initializers) {
        window.oio.initializers.forEach((process) => {
          handle(process);
        });
      }
      window.oio.init = (...args) => handle(args);
    }
    const hasJquery = Boolean(document.querySelector('script[data-hid="jquery"]'));
    if (!hasJquery) {
      oLog('Process Initializers directly');
      processInitializers();
    } else {
      eventBus.on('load-jquery', () => {
        oLog('Process Initializers after Jquery Load');
        processInitializers();
      });
    }

    onBeforeUnmount(() => {
      window.oio = '';
      eventBus.off('load-jquery');
    });

    function handle(action) {
      try {
        if (typeof action[0] === 'function') {
          return action[0]();
        } else if (action[0] === 'loadscript' && action.length > 1) {
          return loader(action[1]);
        } else if (action[0] === 'loadscriptSync' && action.length > 1) {
          return loadScriptSync(action[1], action[2]);
        }
      } catch (error) {
        console.error(error);
      }
    }

    function loader(scriptUrl) {
      // if (document.querySelector('script[src="' + scriptUrl + '"]')) {
      //   return;
      // }
      const script = document.createElement('script');
      script.src = scriptUrl;
      document.head.appendChild(script);
    }

    function loadScriptSync(url, callback) {
      if (document.querySelector('script[src="' + url + '"]')) {
        // If script already loaded, just execute callback
        callback();
        return;
      }
      const script = document.createElement('script');
      if (script.readyState) {
        // only required for IE <9
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = function () {
          callback();
        };
      }

      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  });
}
